import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaChevronLeft, FaChevronRight, FaShoppingCart } from "react-icons/fa";
import { FaMinus } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import socket from "../../assets/socket"; // path to your socket.js
import toast from "react-hot-toast";

const base_url = process.env.REACT_APP_API_URL;

const AdminSpinWheel = () => {
  const token = localStorage.getItem("admin_token");
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isExpanded, setIsExpanded] = useState(null);
  const [showBettingStatistics, setShowBettingStatics] = useState(true);

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const [data, setData] = useState([]);
  const [userData, setUserData] = useState([]); // work for user data tomorrow
  const [join, setJoin] = useState([]);
  const [periodNumber, setPeriodNumber] = useState([]);
  const [gameTimeHidden, setGame] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeGoIndex, setActiveGoIndexData] = useState(null);
  const [page, setPage] = useState(1);
  const limit = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [page2, setPage2] = useState(1);
  const limit2 = 10;
  const [totalPages2, setTotalPages2] = useState(1);
  const [resultDefined, setResultDefined] = useState("Random");

  // socket start
  useEffect(() => {
    const handleSocketData = async (payload) => {
      console.log("🔁 Socket Received:", payload);

      try {
        const response = await axios.get(`${base_url}/api/get/spinWheelData`, {
          params: { page, page2, limit, limit2 },
          headers: {
            Authorization: token,
          },
        });

        setResultDefined("Random");
        setData(response.data.data);
        setUserData(response.data.userData);
        setPeriodNumber(response.data.periodNumber);
        setLoading(false);
        setTotalPages(response.data.totalPages);
        setTotalPages2(response.data.totalPages2);

        let resData = response.data;

        // Default join setup
        const defaultJoin = [
          {
            icon: <FaShoppingCart />,
            title: "Join Overall Amount",
            key: "totalOverallAmountJoin",
            value: "0",
          },
          { icon: "0", title: "Join 0", key: "total0Join", value: "0" },
          { icon: "1", title: "Join 1", key: "total1Join", value: "0" },
          { icon: "2", title: "Join 2", key: "total2Join", value: "0" },
          { icon: "3", title: "Join 3", key: "total3Join", value: "0" },
          { icon: "4", title: "Join 4", key: "total4Join", value: "0" },
          { icon: "5", title: "Join 5", key: "total5Join", value: "0" },
          { icon: "6", title: "Join 6", key: "total6Join", value: "0" },
          { icon: "7", title: "Join 7", key: "total7Join", value: "0" },
          { icon: "8", title: "Join 8", key: "total8Join", value: "0" },
          { icon: "9", title: "Join 9", key: "total9Join", value: "0" },
          { icon: "O", title: "Join Odd", key: "totalOddJoin", value: "0" },
          { icon: "E", title: "Join Even", key: "totalEvenJoin", value: "0" },
        ];

        // Update the join values using response.data
        const updatedJoin = defaultJoin.map((item) => ({
          ...item,
          value:
            resData[item.key] !== undefined && resData[item.key] !== null
              ? resData[item.key].toString()
              : "0",
        }));

        setJoin(updatedJoin);

        // ✅ Start relevant timer
        const duration = Number(gameTimeHidden);
        const initialIndex = timersConfig.findIndex(
          (t) => t.duration === duration,
        );
        if (initialIndex !== -1) {
          startTimer(initialIndex);
        }
      } catch (error) {
        console.error("❌ Failed to fetch Wingo data:", error.message);
        setLoading(false);
      }
    };

    const handleConnect = () => {
      console.log("✅ Admin Connected to Real-time Wingo Updates");
    };

    socket.on("connect", handleConnect);
    socket.on("spin_wheel_update", handleSocketData);
    socket.on("bet_by_spin_wheel", handleSocketData);

    return () => {
      socket.off("connect", handleConnect);
      socket.off("spin_wheel_update", handleSocketData);
      socket.off("bet_by_spin_wheel", handleSocketData);
    };
  }, [gameTimeHidden]);
  // socket end

  // load to get data start
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${base_url}/api/get/spinWheelData`, {
          params: { game: 30, page, page2, limit, limit2 },
          headers: {
            Authorization: token,
          },
        });

        setGame(30);
        setUserData(response.data.userData);
        setPeriodNumber(response.data.periodNumber);
        setLoading(false);
        setTotalPages(response.data.totalPages);
        setTotalPages2(response.data.totalPages2);

        const now = new Date();
        const seconds = now.getSeconds();
        const timerSeconds = 30 - (seconds % 30); // Remaining seconds in current 30s cycle

        // Set the 30s timer manually (since you're syncing with a 30s game)
        const index = timersConfig.findIndex((t) => t.duration === 30);
        if (index !== -1) {
          setTimers((prev) =>
            prev.map((t, i) =>
              i === index
                ? {
                    ...t,
                    isRunning: true,
                    isFinished: false,
                    timeLeft: timerSeconds,
                  }
                : { ...t, isRunning: false },
            ),
          );
          setActiveGoIndexData(index);
        }
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  // load to get data end

  // click to get data start
  const handleGameSubmit = async (gameTime) => {
    try {
      const response = await axios.get(`${base_url}/api/get/spinWheelData`, {
        params: { game: gameTime, page, page2, limit, limit2 },
        headers: {
          Authorization: token,
        },
      });

      const resData = response.data;

      const processedData = resData.data.map((item) => {
        let colors = [];

        if (item.number === 0) colors = ["Red", "Violet"];
        else if (item.number === 5) colors = ["Green", "Violet"];
        else if ([1, 3, 7, 9].includes(item.number)) colors = ["Green"];
        else if ([2, 4, 6, 8].includes(item.number)) colors = ["Red"];

        return { ...item, colors };
      });

      setGame(gameTime);
      setData(processedData);
      setUserData(response.data.userData);
      setPeriodNumber(resData.periodNumber);
      setTotalPages(resData.totalPages);
      setTotalPages2(resData.totalPages2);

      const lastTime = resData.lastGameTime;

      // Default join setup
      const defaultJoin = [
        {
          icon: <FaShoppingCart />,
          title: "Join Overall Amount",
          key: "totalOverallAmountJoin",
          value: "0",
        },
        { icon: "0", title: "Join 0", key: "total0Join", value: "0" },
        { icon: "1", title: "Join 1", key: "total1Join", value: "0" },
        { icon: "2", title: "Join 2", key: "total2Join", value: "0" },
        { icon: "3", title: "Join 3", key: "total3Join", value: "0" },
        { icon: "4", title: "Join 4", key: "total4Join", value: "0" },
        { icon: "5", title: "Join 5", key: "total5Join", value: "0" },
        { icon: "6", title: "Join 6", key: "total6Join", value: "0" },
        { icon: "7", title: "Join 7", key: "total7Join", value: "0" },
        { icon: "8", title: "Join 8", key: "total8Join", value: "0" },
        { icon: "9", title: "Join 9", key: "total9Join", value: "0" },
        { icon: "O", title: "Join Odd", key: "totalOddJoin", value: "0" },
        { icon: "E", title: "Join Even", key: "totalEvenJoin", value: "0" },
      ];

      // Update the join values using response.data
      const updatedJoin = defaultJoin.map((item) => ({
        ...item,
        value:
          resData[item.key] !== undefined && resData[item.key] !== null
            ? resData[item.key].toString()
            : "0",
      }));

      setJoin(updatedJoin);

      // Timer Logic
      const [lastHours, lastMinutes, lastSeconds] = lastTime
        .split(":")
        .map(Number);
      const now = new Date();
      const lastDate = new Date(now);
      lastDate.setHours(lastHours, lastMinutes, lastSeconds, 0);

      const secondsPassed = Math.floor((now - lastDate) / 1000);
      const timerSeconds = gameTime - (secondsPassed % gameTime);

      const index = timersConfig.findIndex((t) => t.duration === gameTime);
      if (index !== -1) {
        setTimers((prev) =>
          prev.map((t, i) =>
            i === index
              ? {
                  ...t,
                  isRunning: true,
                  isFinished: false,
                  timeLeft: timerSeconds,
                }
              : { ...t, isRunning: false },
          ),
        );
        setActiveGoIndexData(index);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  // click to get data end

  const timeFormat = (time) => {
    const minutes = String(Math.floor(time / 60)).padStart(2, "0");
    const seconds = String(time % 60).padStart(2, "0");
    return { minutes, seconds };
  };

  const timersConfig = [{ label: "30 sec", duration: 30 }];

  const [timers, setTimers] = useState(
    timersConfig.map((timer) => ({
      ...timer,
      timeLeft: timer.duration,
      isRunning: false,
      isFinished: false,
    })),
  );

  // Timer logic
  useEffect(() => {
    const interval = setInterval(() => {
      setTimers((prevTimers) =>
        prevTimers.map((timer, index) => {
          if (index === activeGoIndex && timer.isRunning && timer.timeLeft) {
            const updatedTimeLeft = timer.timeLeft - 1;
            return {
              ...timer,
              timeLeft: updatedTimeLeft,
              isRunning: updatedTimeLeft,
              isFinished: updatedTimeLeft === 0,
            };
          }
          return timer;
        }),
      );
    }, 1000);

    return () => clearInterval(interval);
  }, [activeGoIndex]);

  const startTimer = (index) => {
    setActiveGoIndexData(index);
    setTimers((prev) =>
      prev.map((t, i) =>
        i === index
          ? { ...t, isRunning: true, isFinished: false, timeLeft: t.duration }
          : { ...t, isRunning: false },
      ),
    );
  };

  const { minutes, seconds } = timeFormat(timers[activeGoIndex]?.timeLeft || 0);

  // number submit
  const hendleGameNumberSubmit = async () => {
    try {
      const number = document.getElementById("gameNumber").value;

      if (number.length > 1) {
        toast.error("Please enter a single digit between 0 and 9.");
        return;
      }

      const response = await axios.post(
        `${base_url}/api/post/spinWheelNumber`,
        {
          period: periodNumber,
          number: number,
        },
        {
          headers: {
            Authorization: token,
          },
        },
      );

      if (response.data.success) {
        setResultDefined(number);
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("❌ Error submitting game number:", error);
      toast.error("Something went wrong.");
    }
  };

  useEffect(() => {
    if (gameTimeHidden) {
      handleGameSubmit(gameTimeHidden);
    }
  }, [page, page2, gameTimeHidden]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="wrapper">
      <div
        className={`content-wrapper ${
          isSidebarOpen ? "" : "open-content-wrapper"
        }`}
      >
        <div>
          <section className="content-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-6 m-0">
                  <h1>Spin Wheel</h1>
                </div>
              </div>
            </div>
          </section>

          {/* join section */}
          <section className="p-4 rounded mx-2 ml-1 mb-2">
            <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4">
              {join.map((item) => {
                let bgColor = "#007BFF"; // default
                if (item.title.includes("Even")) bgColor = "#27ae60";
                else if (item.title.includes("Odd")) bgColor = "#f39c12";
                else if (item.title.includes("Overall")) bgColor = "#e74c3c";
                else if (!isNaN(item.icon))
                  bgColor = "#007BFF"; // for numbers
                else bgColor = "#7f8c8d"; // fallback

                return (
                  <div key={item.title} className="col">
                    <div
                      className="d-flex align-items-center gap-3 p-2 rounded h-100"
                      style={{
                        backgroundColor: "#343A40",
                        boxShadow:
                          "0 8px 16px rgba(0, 0, 0, 0.2), 0 4px 4px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <div
                        className="d-flex flex-column justify-content-center align-items-center p-2 rounded"
                        style={{
                          width: "5rem",
                          height: "5rem",
                          backgroundColor: bgColor,
                        }}
                      >
                        <div style={{ fontSize: "2.5rem", color: "white" }}>
                          {item.icon}
                        </div>
                      </div>
                      <div className="d-flex flex-column gap-3 text-start fs-5">
                        <h6 className="m-0 text-white">{item.title}</h6>
                        <p className="m-0 text-white">{item.value}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>

          {/* betting statistics */}
          {showBettingStatistics && (
            <section
              className="mx-4 ml-1 mb-4 border-0 shadow-lg rounded overflow-hidden"
              style={{
                backgroundColor: "#343A40",
                boxShadow:
                  "0 8px 16px rgba(0, 0, 0, 0.2), 0 4px 4px rgba(0, 0, 0, 0.1)",
              }}
            >
              <div
                className="d-flex align-content-center justify-content-between"
                style={{ backgroundColor: "#3F6791" }}
              >
                {/* Header */}
                <h5 className="text-white p-3 rounded-top m-0">
                  Betting Statistics
                </h5>
                <div className="d-flex align-content-center justify-content-between">
                  <button
                    className="border-0 bg-transparent"
                    onClick={() => {
                      setIsExpanded(!isExpanded);
                    }}
                  >
                    {isExpanded ? <FaMinus /> : <FaPlus />}
                  </button>
                  <button
                    className="border-0 bg-transparent"
                    onClick={() =>
                      setShowBettingStatics(!showBettingStatistics)
                    }
                  >
                    <RxCross2 />
                  </button>
                </div>
              </div>
              {/* Content Wrapper with vertical spacing */}
              {isExpanded && (
                <div
                  className="text-white px-3 pt-3 d-flex flex-column gap-3"
                  style={{ fontSize: "clamp(0.8rem, 2.5vw, 1rem)" }}
                >
                  <div
                    className="table-responsive border-0 text-white shadow-lg rounded-bottom"
                    style={{ backgroundColor: "#343A40" }}
                  >
                    <table className="table table-hover text-center mb-0 text-white custom-table">
                      <thead>
                        <tr className="">
                          <th
                            className="thead-center border-bottom"
                            style={{ fontSize: "1.1rem" }}
                          >
                            Period
                          </th>
                          <th
                            className="thead-center border-bottom"
                            style={{ fontSize: "1.1rem" }}
                          >
                            Phone
                          </th>
                          <th
                            className="thead-center border-bottom"
                            style={{ fontSize: "1.1rem" }}
                          >
                            Selected
                          </th>
                          <th
                            className="thead-center border-bottom"
                            style={{ fontSize: "1.1rem" }}
                          >
                            Result
                          </th>
                          <th
                            className="thead-center border-bottom"
                            style={{ fontSize: "1.1rem" }}
                          >
                            Bet Amount
                          </th>
                          <th
                            className="thead-center border-bottom"
                            style={{ fontSize: "1.1rem" }}
                          >
                            Win Amount
                          </th>
                          <th
                            className="thead-center border-bottom"
                            style={{ fontSize: "1.1rem" }}
                          >
                            Current Money
                          </th>
                          <th
                            className="thead-center border-bottom"
                            style={{ fontSize: "1.1rem" }}
                          >
                            Date
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {userData.map((item, idx) => {
                          return (
                            <tr key={idx}>
                              <td className="bg-transparent text-white">
                                {item.period}
                              </td>
                              <td className="bg-transparent text-white">
                                {item.phone}
                              </td>
                              <td className="bg-transparent text-white">
                                {item.selected_data &&
                                  JSON.parse(item.selected_data).map(
                                    (data, index) => (
                                      <div key={index}>
                                        {Object.keys(data).join(", ")}
                                      </div>
                                    ),
                                  )}
                              </td>
                              <td className="bg-transparent text-white">
                                {item.result},{" "}
                                {item.result % 2 ? "odd" : "even"}
                              </td>
                              <td className="bg-transparent text-white">
                                {item.totalBetAmount.toLocaleString(2)}
                              </td>
                              <td className="bg-transparent text-white">
                                {item.winAmount.toLocaleString(2)}
                              </td>
                              <td className="bg-transparent text-white">
                                {item.current_money.toLocaleString(2)}
                              </td>
                              <td className="bg-transparent text-white">
                                {new Date(item.created_at).toLocaleString()}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>

                    <div className="d-flex justify-content-center my-3 gap-2">
                      <button
                        className="border-0 bg-primary rounded px-2"
                        disabled={page2 <= 1}
                        onClick={() =>
                          setPage2((prev) => Math.max(prev - 1, 1))
                        }
                      >
                        <FaChevronLeft />
                      </button>
                      <span className="align-self-center">
                        Page {page2} of {totalPages2}
                      </span>
                      <button
                        className="border-0 bg-primary rounded px-2"
                        disabled={page2 >= totalPages2}
                        onClick={() =>
                          setPage2((prev) => Math.min(prev + 1, totalPages2))
                        }
                      >
                        <FaChevronRight />
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {/* Submit Button Centered */}
              <div
                className="d-flex justify-content-center py-3"
                style={{ backgroundColor: "#2F3439" }}
              ></div>
            </section>
          )}
          {/* Peroids table */}
          <section className="mx-4 ml-1 mb-3 shadow-lg rounded">
            <div
              className="p-3 align-items-center justify-content-center rounded-top d-flex flex-column"
              style={{ backgroundColor: "#3F6791" }}
            >
              <h1 className="text-white">{periodNumber}</h1>
              <p className="h5 fw-bold d-flex justify-content-end gap-2">
                <span className="p-2 bg-white">{minutes[0]}</span>
                <span className="p-2 bg-white">{minutes[1]}</span>
                <span className="p-2 bg-white">:</span>
                <span className="p-2 bg-white">{seconds[0]}</span>
                <span className="p-2 bg-white">{seconds[1]}</span>
              </p>
            </div>
            <div
              className="table-responsive border-0 text-white shadow-lg rounded-bottom"
              style={{ backgroundColor: "#343A40" }}
            >
              <table className="table table-hover text-center mb-0 text-white custom-table">
                <thead>
                  <tr className="">
                    <th
                      className="thead-center border-bottom"
                      style={{ fontSize: "1.1rem" }}
                    >
                      Period
                    </th>
                    <th
                      className="thead-center border-bottom"
                      style={{ fontSize: "1.1rem" }}
                    >
                      Result
                    </th>
                    <th
                      className="thead-center border-bottom"
                      style={{ fontSize: "1.1rem" }}
                    >
                      Odd/Even
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, idx) => {
                    return (
                      <tr key={item.id}>
                        <td className="bg-transparent text-white">
                          {item.period}
                        </td>
                        <td className="bg-transparent text-center d-inline-block">
                          <span
                            key={`${item.id}-${item.result}`}
                            style={{ color: "#fff" }}
                          >
                            {item.result}
                          </span>
                        </td>
                        <td className="text-white bg-transparent">
                          {item.result % 2 !== 0 ? "Odd" : "Even"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              <div className="d-flex justify-content-center mt-3 gap-2 mb-3">
                <button
                  className="d-flex flex-column border-0 bg-primary rounded align-content-center justify-content-center p-2"
                  disabled={page <= 1}
                  onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                >
                  <FaChevronLeft />
                </button>
                <span className="align-self-center">
                  Page {page} of {totalPages}
                </span>
                <button
                  className="d-flex flex-column border-0 bg-primary rounded align-content-center justify-content-center p-2"
                  disabled={page >= totalPages}
                  onClick={() =>
                    setPage((prev) => Math.min(prev + 1, totalPages))
                  }
                >
                  <FaChevronRight />
                </button>
              </div>
            </div>
          </section>

          {/* Search field      */}

          <section
            className="mx-4 ml-1 mb-4 shadow-lg rounded"
            style={{
              backgroundColor: "#343A40",
              boxShadow:
                "0 8px 16px rgba(0, 0, 0, 0.2), 0 4px 4px rgba(0, 0, 0, 0.1)",
            }}
          >
            {/* Header */}
            <h5
              className="text-white p-3 rounded-top m-0"
              style={{ backgroundColor: "#3F6791" }}
            >
              Adjust Result
            </h5>

            {/* Content Wrapper with vertical spacing */}
            <div
              className="text-white px-3 pt-3 d-flex flex-column gap-3"
              style={{ fontSize: "clamp(0.8rem, 2.5vw, 1rem)" }}
            >
              {/* Info Text */}
              <p className="mb-0 fs-6 fs-md-5 fs-lg-4">
                1, 3, 5, 7, 9 (Odd) | 0, 2, 4, 6, 8 (Even)
              </p>

              {/* Input Label and Field */}
              <label className="form-label w-100">
                <span className="text-white mb-1 d-block fw-bold fs-5">
                  Next Result: {resultDefined}
                </span>

                <input
                  name="game"
                  id="gameName"
                  type="hidden"
                  value={gameTimeHidden}
                />

                <input
                  name="number"
                  id="gameNumber"
                  type="number"
                  placeholder="Enter the result (e.g., 1)"
                  className="w-100 bg-transparent border border-secondary text-white rounded-3 p-2"
                  style={{
                    backgroundColor: "#343A40",
                    borderRadius: "0.5rem",
                    overflow: "hidden",
                    outline: "none",
                  }}
                />
              </label>
            </div>

            {/* Submit Button Centered */}
            <div
              className="d-flex justify-content-center py-3"
              style={{ backgroundColor: "#2F3439" }}
            >
              <button
                className="border-0 px-4 py-2 text-white rounded"
                style={{ backgroundColor: "#3F6791" }}
                onClick={() => hendleGameNumberSubmit()}
              >
                Submit
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AdminSpinWheel;
